import { getDebitOrCredit } from '@tradingblock/api';
import {
  DebitOrCredit,
  Legs,
  Order,
  OrderAction,
  OrderLeg,
  TradingStrategy,
  TradingStrategyNameOrCustom,
} from '@tradingblock/types';

export interface ConfirmDebitCreditContextForPreview {
  mid: number | undefined;
  openingNetDebitMinusCredit: number | undefined;
  strategy: TradingStrategyNameOrCustom | undefined;
  legs: Legs | undefined;
  validationMatch: TradingStrategy | undefined;
  order: Order<OrderLeg> | undefined;
  blockDebitCreditFallback: DebitOrCredit | undefined;
}

export function buildConfirmDebitCreditContextForPreview(
  params: ConfirmDebitCreditContextForPreview,
): ConfirmDebitCreditContextForPreview {
  return params;
}

/**
 * Resolves debit vs credit for confirm/preview using the same rules as the order ticket (`getDebitOrCredit`).
 */
export function resolveConfirmOrderDebitCredit(
  order: Order<OrderLeg>,
  context: ConfirmDebitCreditContextForPreview,
): DebitOrCredit | undefined {
  const legs: Legs = context.legs != null ? context.legs : ({} as Legs);
  const action = order.Action != null ? order.Action : OrderAction.Buy;
  const price = order.Price != null ? order.Price : 0;

  try {
    const resolved = getDebitOrCredit({
      strategy: context.strategy,
      action,
      currentDebitOrCredit: order.DebitCredit,
      price,
      updateCreditOrDebit: true,
      legs,
      mid: context.mid,
      match: context.validationMatch,
    });
    if (resolved !== null && resolved !== undefined) {
      return resolved;
    }
  } catch (err) {
    console.error('[resolveConfirmOrderDebitCredit] getDebitOrCredit failed', err);
  }

  if (order.DebitCredit != null && order.DebitCredit !== undefined) {
    return order.DebitCredit;
  }
  return context.blockDebitCreditFallback;
}
